import '../style/cardStyle.css';
import { useSelector } from 'react-redux';
import CardCom from '../components/Card';
import { Typography } from '@mui/material';
import Progress from '../components/prograssBar';
import { Helmet } from 'react-helmet-async';

export default function AthkarElMasaa() {
    const value = useSelector((state) => state.athkarElmasaa.value);
    const card = useSelector((state) => state.athkarElmasaa.data);


    return (
        <>
        <Helmet>
            <title>أذكار المساء</title>
            <meta name='description' content='اذكار المساء'/>
            <link rel="canonical" href="/athkarElmasaa"/>
        </Helmet>
        <div className='mainScreen'>
          <Progress value={value}/>
          <Typography variant="h3" component="p" className='title' sx={{ color: "text.primary"}}>أذكار المساء</Typography>
            <CardCom card={card} type={'masaa'}/>
        </div>

        </>
    );
}
